<div *ngIf="checkViewMode('edit') && hasChildren" class="form-group {{getOptionByKey(attribute,'class')}}" >
  <label *ngIf="getHideTitle() === 'false' ">
    {{getOptionByKey(attribute,'hideTitle') == 'true'? '' : getTitle()}}
    <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
    <div *ngIf="getOptionByKey(attribute,'tooltip')"
      class="popover-info"
      [popover]="getOptionByKey(attribute,'tooltip')"
      placement="right"
      container="body"
      triggers="mouseenter:mouseleave">
      <i class="fa fa-question-circle"></i>
    </div>
  </label>
  <div class="form-check" *ngFor="let option of attribute.attributes">
    <input class="form-check-input"
        type="checkbox"
        (change)="onValueChange($event)"
        name="{{attribute.key}}"
        value="{{option.key}}"
        id="{{getKeyForIdentifier(attribute.key)}}-{{getKeyForIdentifier(option.key)}}"
        [checked]="getBooleanOptionByKey(option,'checked')"
        [disabled]="checkViewMode('view')">
    <label class="form-check-label"
        for="{{getKeyForIdentifier(attribute.key)}}-{{getKeyForIdentifier(option.key)}}">
        {{option.value}}
    </label>
  </div>
</div>

<div *ngIf="checkViewMode('edit') && !hasChildren" class="form-group {{getOptionByKey(attribute,'class')}}" >
  <div class="form-check">
    <input class="form-check-input"
        type="checkbox"
        (change)="onValueChange($event)"
        value="{{attribute.key}}"
        id="{{getKeyForIdentifier(attribute.key)}}"
        [checked]="isChecked"
        [disabled]="checkViewMode('view')">
    <label class="form-check-label"
        for="{{getKeyForIdentifier(attribute.key)}}">
        {{getTitle()}}
        <span class="error-indication" *ngIf="!isValid">{{ errorSign }}</span>
        <div *ngIf="getOptionByKey(attribute,'tooltip')"
          class="popover-info"
          [popover]="getOptionByKey(attribute,'tooltip')"
          placement="right"
          container="body"
          triggers="mouseenter:mouseleave">
          <i class="fa fa-question-circle"></i>
        </div>
    </label>
  </div>
</div>

<div *ngIf="checkViewMode('view') && !hasChildren">
  <p><span>{{ getTitle() }}: </span> {{ getValue() }}</p>
</div>